import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"

export async function getChannels() {
  const channelApi = "/v1/channels";
  let channel_table = {}

  await axios
    .get(channelApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("channelNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
    })
    .then((response) => {
      if (response.data.channel_table != undefined) {
        channel_table = response.data.channel_table
      }
    })

  return channel_table
}

export async function updateChannel(channel_uuid, data) {
  const channelApi = "/v1/channels/" + channel_uuid;

  await axios
    .put(channelApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("channelNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}